var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "114.000000pt",
    height: "114.000000pt",
    viewBox: "0 0 114.000000 114.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,114.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165 1116 c-64 -29 -112 -77 -141 -141 -24 -49 -24 -54 -24 -405 0 -351 0 -356 24 -405 29 -64 77 -112 141 -141 49 -24 54 -24 405 -24 351 0 356 0 405 24 64 29 112 77 141 141 24 49 24 54 24 405 0 351 0 356 -24 405 -29 64 -77 112 -141 141 -49 24 -54 24 -405 24 -351 0 -356 0 -405 -24z m255 -346 l0 -120 145 0 145 0 0 120 0 120 45 0 45 0 0 -295 0 -295 -45 0 -45 0 0 135 0 135 -145 0 -145 0 0 -135 0 -135 -40 0 -40 0 0 295 0 295 40 0 40 0 0 -120z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5608a7fb949f6b1ccef98feb37008cf1.svg";
export { ForwardRef as ReactComponent };